import { IICodeUKTZEDCategoryData } from '../ii-code-uktzed/ii-code-uktzed.models';

export const brandModelMaxLength = 100;

export function getBrandModelTooltipMessage(data: IICodeUKTZEDCategoryData): string {
  return Object.values(data)
    .map(entry => `• ${entry.categoryName}: ${entry.categoryExample}`)
    .join('\n');
}
